import DropdownService from "@/services/APIs/DropdownService";
import { ManageActiveRecordParams } from "@/utils/types/activeRecord";
import { Switch } from "antd";
import { useEffect, useState } from "react";
import { notify } from "@components/common/Notification";

interface ActiveToggleButtonProps {
  table: string;
  pk: string;
  is_active: boolean;
  disabled?: boolean;
  size?: "small" | "default";
  className?: string;
}

const ActiveToggleButton: React.FC<ActiveToggleButtonProps> = ({
  table,
  pk,
  is_active: initialIsActive,
  disabled = false,
  size = "small",
  className = "",
}) => {
  const [isActive, setIsActive] = useState<boolean>(initialIsActive);
  const [loading, setLoading] = useState<boolean>(false);

  // Update local state when prop changes
  useEffect(() => {
    setIsActive(initialIsActive);
  }, [initialIsActive]);

  const handleToggle = async (checked: boolean) => {
    if (loading || disabled) {
      return;
    }
    setLoading(true);
    const params: ManageActiveRecordParams = {
      table,
      pk,
      is_active: checked,
    };
    const response = await DropdownService.manageActiveRecord(params);
    if (response?.status === 200) {
      setIsActive(checked);
      notify.success(response.code, response.message);
    } else {
      notify.error(response.code, response.message);
    }
    setLoading(false);
  };

  return (
    <Switch
      checked={isActive}
      onChange={handleToggle}
      loading={loading}
      disabled={disabled}
      size={size}
      className={className}
    />
  );
};

export default ActiveToggleButton;
